<template>
    <form class="stylesheet-delete" @submit.prevent="openModal">
        <slot :open="openModal">
            <button class="button button--blank">
                <IconBin :fill="iconFill" />
            </button>
        </slot>

        <portal to="modals">
            <ConfirmModal
                v-if="opened"
                name="order-stylesheet-delete"
                :title="$t('crm.stylesheet.delete.title')"
                :ok-label="$t('misc.delete')"
                @confirmed="confirmed"
                @canceled="closeModal"
            >
                <template #content>
                    <slot name="confirm-content">
                        <p v-text="$t('crm.stylesheet.delete.content')" />
                    </slot>
                </template>
            </ConfirmModal>
        </portal>
    </form>
</template>

<script>
import { ConfirmModal } from '@speechki-frontend/shared/ui/modals';
import { IconBin } from '@speechki-frontend/shared/ui/icons';

export default {
    name: 'StylesheetDelete',
    components: {
        ConfirmModal,
        IconBin,
    },
    props: {
        iconFill: {
            type: String,
            default: 'red',
        },
    },
    data() {
        return {
            opened: false,
        };
    },
    methods: {
        openModal() {
            this.opened = true;
            this.$emit('opened');
        },
        closeModal() {
            this.opened = false;
            this.$emit('closed');
        },
        confirmed() {
            this.$emit('confirmed');
            this.closeModal();
        },
    },
};
</script>
